module.exports = __webpack_public_path__ + "static/img/h5_school_info_top_new.002caecc.jpg";